import React, { useState } from 'react';
import { InputGroup } from 'reactstrap';
import isEmail from 'validator/lib/isEmail';
import { ModalBody, ModalHeader } from '../modal-helpers';
import TextInput from '../../components/TextInput';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './ExportModal.scss';
import { ModalInstanceProps } from '../interfaces';
import { ExportModalProps } from '@mm/state/modules/modalsState/actions';

type Props = ModalInstanceProps & ExportModalProps;

export const ExportModal = (props: Props) => {
  const { closeModal, description, title, onExport } = props;
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const onExportClick = (email: string) => {
    if (email && isEmail(email)) {
      onExport(email.trim());
      setError('');
      closeModal();
    } else {
      setError('Please enter a valid email.');
    }
  };
  return (
    <div className="export-modal">
      <ModalHeader>
        <h3>{title}</h3>
      </ModalHeader>
      <ModalBody>
        <p>{description}</p>
        <InputGroup className="mb-3 chatbot__input-group page-overview__text-input">
          <TextInput
            placeholder="Enter email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <p className="export-modal__error">{error}</p>
        </InputGroup>
        <Button
          className="export-modal__btn"
          onClick={() => onExportClick(email)}
        >
          OK
        </Button>
        <Button red className="export-modal__btn" onClick={closeModal}>
          Cancel
        </Button>
      </ModalBody>
    </div>
  );
};
